import { GSTConstants } from '../Constants';
import { GSTService } from '../Services';

export const GSTActions = {
    postOTPGeneration,
    postFetchMutipleGST,
    postGSTData,
    // storeOldGstin
}

function postOTPGeneration(GST) {
    return dispatch => {
        dispatch(request());
        GSTService.postOTPGeneration(GST)
            .then(gst => dispatch(success(gst)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: GSTConstants.POST_GST_REQUEST } }
    function success(GST) { return { type: GSTConstants.POST_GST_SUCCESS, GST } }
    function failure(error) { return { type: GSTConstants.POST_GST_FAILURE, error } }
}

function postFetchMutipleGST(GST) {
    return dispatch => {
        dispatch(request());
        GSTService.postFetchMutipleGST(GST)
            .then(gst => dispatch(success(gst)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: GSTConstants.POST_MUTIPLE_GST_REQUEST } }
    function success(GST) { return { type: GSTConstants.POST_MUTIPLE_GST_SUCCESS, GST } }
    function failure(error) { return { type: GSTConstants.POST_MUTIPLE_GST_FAILURE, error } }
}

function postGSTData(GST) {
    return dispatch => {
        dispatch(request());
        GSTService.postGSTData(GST)
            .then(gst => dispatch(success(gst)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: GSTConstants.POST_GST_DATA_REQUEST } }
    function success(GST) { return { type: GSTConstants.POST_GST_DATA_SUCCESS, GST } }
    function failure(error) { return { type: GSTConstants.POST_GST_DATA_FAILURE, error } }
}

// function storeOldGstin(GST) {
//     return dispatch => {
//         dispatch(request());
//         dispatch(success(GST));
//     };

//     function request() { return { type: 'STORE_OLD_GSTIN_REQUEST' } }
//     function success(GST) { return { type: 'STORE_OLD_GSTIN_SUCCESS', GST } }
// }